"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.questions.empty': 'Nessuna domanda configurata per questo passo ancora.',
    'onboarding.questions.placeholder.text': 'Inserisci la tua risposta',
    'onboarding.questions.placeholder.textarea': 'Inserisci la tua risposta',
    'onboarding.questions.placeholder.number': 'Inserisci numero',
    'onboarding.questions.placeholder.select': '-- Seleziona Opzione --',
    'onboarding.questions.required': '*',
};
